import container from './container';
import SignOut from './SignOut';

export default container(SignOut);
